import { withTranslation } from "react-i18next";

import React from 'react';
import { Link } from 'react-router-dom';
import { LoginHeader } from '../Common/LoginHeader';
import { connect } from 'react-redux';
import { sellerRegisterForm } from '../../Action/registration';
import { withRouter } from 'react-router-dom';
import { Footer } from '../Common';
import SimpleReactValidator from 'simple-react-validator';
import BuyerUser from '../../Models/BuyerUser';

class SellerRegistrationForm extends React.Component {
    constructor(props) {
        super(props);
        // let i=window.localStorage.getItem('email');
        this.state = {
            _id: false,
            email: '',
            username: '',
            password: '',
            status: '',
            selectOption: '',
            termCondition: '',
            errors: [],
        };
        SimpleReactValidator.addLocale('klingon', {
            integer: `${this.props.t('12')}`,
            max: `:attribute :max ${this.props.t('10')} .`,
            required: ` :attribute ${this.props.t('17')}`,
            min: `:attribute :min ${this.props.t('11')}`,
        });
        this.validator = new SimpleReactValidator({
            autoForceUpdate: this,
            locale: 'klingon',
        })
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }
    updateValue(type, e) {
        var obj = {};
        obj[type] = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        this.setState(obj);
    }

    radioChange(e) {
        this.setState({
            selectOption: e.target.value
        });

    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.errors) {
            console.log(nextProps.errors)
            this.setState({ errors: nextProps.errors })
            console.log('ads', this.state.errors);
        }
    }
    handleSubmit(e) {
        e.preventDefault();
        if (this.validator.allValid()) {
            if (this.state.termCondition === true) {
                let data = {}
                data = {
                    email: JSON.parse(window.localStorage.getItem('email')),
                    name: this.state.username,
                    password: this.state.password,
                }
                console.log(data)
                this.props.sellerRegisterForm(data, this.props.history);
            } else {
                alert(this.props.t('1'))
            }
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }
    checkValue(a) {
        this.validator.showMessageFor(a)
        // let data = {
        let name = this.state.username
        // }
        BuyerUser.getUserName(name, 0).then(res => {
            // console.log(res.data)
            if (res.data.status === 200) {
                alert(this.props.t('0'))
                this.state.username = ''
                this.setState({ status: res.data.status })
            } else {
                this.state.username = this.state.username
            }
        })
    }
    userName() {
        const isMobile = window.innerWidth <= 500;
        if (isMobile) {
            if (this.state.status === 200) {
                return (
                    <div className="row col-md-12">
                        <div className="field_names"style={{width:'50%',textAlign:'left'}}> {this.props.t('18')}</div>
                        <div className="blank_line"></div>
                        <input type="text" className="input_box" placeholder={this.props.t('2')} onChange={this.updateValue.bind(this, 'username')} onBlur={this.checkValue.bind(this, this.props.t('18'))} /><br />
                        <span style={{ color: "red", fontSize: '12px' }}>{this.validator.message(this.props.t('18'), this.state.username, 'required ')}</span>
                    </div>
                )
            } else {
                return (
                    <div className="row col-md-12">
                        <div className="field_names"style={{width:'50%',textAlign:'left'}}> {this.props.t('18')}</div>
                        <div className="blank_line"></div>
                        <input type="text" className="input_box" placeholder={this.props.t('2')} value={this.state.username} onChange={this.updateValue.bind(this, 'username')} onBlur={this.checkValue.bind(this, this.props.t('18'))} /><br />
                        <span style={{ color: "red", fontSize: '12px' }}>{this.validator.message(this.props.t('18'), this.state.username, 'required')}</span>
                    </div>
                )
            }
        } else {
            if (this.state.status === 200) {
                return (
                    <div className="row">
                        <div className="field_names"> {this.props.t('18')}</div>
                        <div className="blank_line"></div>
                        <input type="text" className="input_box" placeholder={this.props.t('2')} onChange={this.updateValue.bind(this, 'username')} onBlur={this.checkValue.bind(this, this.props.t('18'))} /><br />
                        <span style={{ color: "red", fontSize: '12px' }}>{this.validator.message(this.props.t('18'), this.state.username, 'required ')}</span>
                    </div>
                )
            } else {
                return (
                    <div className="row">
                        <div className="field_names"> {this.props.t('18')}</div>
                        <div className="blank_line"></div>
                        <input type="text" className="input_box" placeholder={this.props.t('2')} value={this.state.username} onChange={this.updateValue.bind(this, 'username')} onBlur={this.checkValue.bind(this, this.props.t('18'))} /><br />
                        <span style={{ color: "red", fontSize: '12px' }}>{this.validator.message(this.props.t('18'), this.state.username, 'required')}</span>
                    </div>
                )
            }
        }
    }


    render() {
        const { errors } = this.state.errors

        const isMobile = window.innerWidth <= 500;
        if (isMobile) {
            return (
                <div>
                    <div className="container-fluid">
                        <div className="container">
                            <div className="col-md-12 mb-2 " >
                                <div className="">
                                    <LoginHeader />
                                </div>
                            </div>
                            <div className="row mt-5">
                                <div className="col-md-12 tr_blank_big ">
                                    <div className=""></div>
                                </div>
                                <div className="col-md-12">
                                    <div className="row">
                                        <div className="col-md-3"></div>
                                        <div className="col-md-6 form-group " style={{ height: "538px" }}>
                                            <form onSubmit={this.handleSubmit.bind(this)}>
                                                <div className="reg_first"><b>{this.props.t('15')}</b></div>
                                                <div className="dots">
                                                    <hr />
                                                </div>
                                                <div className="mb-2 ml-5 pl-5" style={{ color: "red" }} >{errors}</div>
                                                <div className="row col-md-12">
                                                    <div className="field_names" style={{ width: '50%',textAlign:'left' }} > {this.props.t('13')}</div>
                                                    <div className="blank_line"></div>
                                                    <div><input className="input_box" placeholder="info@domain.com" value={JSON.parse(window.localStorage.getItem('email'))} /></div>
                                                </div>
                                                <div><div>&nbsp;</div></div>
                                                {this.userName()}
                                                <div><div>&nbsp;</div></div>
                                                <div className="row col-md-12">
                                                    <div className="field_names" style={{ width: '50%', textAlign: 'left' }}> {this.props.t('30')}</div>
                                                    <div className="blank_line"></div>
                                                    <div>
                                                        <input type="password" className="input_box" placeholder={this.props.t('6')} value={this.state.password} onChange={this.updateValue.bind(this, "password")} onBlur={() => this.validator.showMessageFor(this.props.t('30'))} /></div>
                                                    <span style={{ color: 'red', fontSize: "12px" }}>
                                                        {this.validator.message(this.props.t('30'), this.state.password, 'required|min:8')}
                                                    </span>
                                                </div>
                                                <div><div>&nbsp;</div></div>
                                                <div className="row col-md-12">
                                                    {/* <div className="field_names"></div> */}
                                                    <div className="blank_line"></div>
                                                    <div className="blank_line"style={{width:'15%'}}></div>
                                                    {/* <div className="blank_line"></div> */}
                                                    <div style={{marginTop:'2px'}}>
                                                        <input type="checkbox" className="" placeholder={this.props.t('6')} value={this.state.termCondition} onChange={this.updateValue.bind(this, "termCondition")} />
                                                    </div>
                                                    <div className="field_names" style={{ paddingTop: '3px', width: '50%',textAlign:'center' }}> <Link to={'/terms-conditions'} target="_blank">{this.props.t('40')}</Link>{this.props.t('33')}</div>


                                                    {/* <span style={{ color: 'red', fontSize: "12px" }}>{this.validator.message(this.props.t('30'), this.state.password, 'required|min:8')}</span> */}
                                                </div>
                                                <div><div>&nbsp;</div></div>
                                                <div className="row">
                                                    <div></div>
                                                    <div className="blank_line"></div>
                                                    <div className="blank_line"></div>
                                                    <div className="remember_text ml-5 ">
                                                        <button type="submit" className="agree_button" style={{ width: '100px' }}>{this.props.t('41')}</button>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                        <div className="col-md-3"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="mt-5" >
                        <div className=" mt-5">
                            <Footer />
                        </div>
                    </div>
                </div>
            );
        } else {
            return (
                <div>
                    <div className="container-fluid">
                        <div className="container">
                            <div className="col-md-12 mb-2 " >
                                <div className="">
                                    <LoginHeader />
                                </div>
                            </div>
                            <div className="row mt-5">
                                <div className="col-md-12 tr_blank_big ">
                                    <div className=""></div>
                                </div>
                                <div className="col-md-12">
                                    <div className="row">
                                        <div className="col-md-3"></div>
                                        <div className="col-md-6 form-group " style={{ height: "538px" }}>
                                            <form onSubmit={this.handleSubmit.bind(this)}>
                                                <div className="reg_first"><b>{this.props.t('15')}</b></div>
                                                <div className="dots">
                                                    <hr />
                                                </div>
                                                <div className="mb-2 ml-5 pl-5" style={{ color: "red" }} >{errors}</div>
                                                <div className="row">
                                                    <div className="field_names"> {this.props.t('13')}</div>
                                                    <div className="blank_line"></div>
                                                    <div><input className="input_box" placeholder="info@domain.com" value={JSON.parse(window.localStorage.getItem('email'))} /></div>
                                                </div>
                                                <div><div>&nbsp;</div></div>
                                                {this.userName()}
                                                <div><div>&nbsp;</div></div>
                                                <div className="row">
                                                    <div className="field_names"> {this.props.t('30')}</div>
                                                    <div className="blank_line"></div>
                                                    <div>
                                                        <input type="password" className="input_box" placeholder={this.props.t('6')} value={this.state.password} onChange={this.updateValue.bind(this, "password")} onBlur={() => this.validator.showMessageFor(this.props.t('30'))} /></div>
                                                    <span style={{ color: 'red', fontSize: "12px" }}>
                                                        {this.validator.message(this.props.t('30'), this.state.password, 'required|min:8')}
                                                    </span>
                                                </div>
                                                <div><div>&nbsp;</div></div>
                                                <div className="row">
                                                    <div className="field_names"></div>
                                                    <div className="blank_line"></div>
                                                    <div>
                                                        <input type="checkbox" className="" placeholder={this.props.t('6')} value={this.state.termCondition} onChange={this.updateValue.bind(this, "termCondition")} />
                                                    </div>
                                                    <div className="field_names" style={{ paddingTop: '3px', width: '25%' }}> <Link to={'/terms-conditions'} target="_blank" >{this.props.t('40')}</Link>{this.props.t('33')}</div>


                                                    {/* <span style={{ color: 'red', fontSize: "12px" }}>{this.validator.message(this.props.t('30'), this.state.password, 'required|min:8')}</span> */}
                                                </div>
                                                <div><div>&nbsp;</div></div>
                                                <div className="row">
                                                    <div></div>
                                                    <div className="blank_line"></div>
                                                    <div className="blank_line"></div>
                                                    <div className="blank_line"></div>
                                                    <div className="remember_text ml-5 pl-5">
                                                        <button type="submit" className="agree_button" style={{ width: '100px' }}>{this.props.t('41')}</button>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                        <div className="col-md-3"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="mt-5" >
                        <div className=" mt-5">
                            <Footer />
                        </div>
                    </div>
                </div>
            );
        }
    }
}

const mapStateToProps = (state) => ({
    sellerRegisterForm: state.sellerRegister,
    errors: state.errors,
});

SellerRegistrationForm = connect(mapStateToProps, { sellerRegisterForm })(withRouter(SellerRegistrationForm));
export { SellerRegistrationForm };

 SellerRegistrationForm = withTranslation('src_Components_Registration_SellerRegistrationForm')(SellerRegistrationForm);
